/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2016] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import x2js from 'x2js';
import transformer from 'jsonpath-object-transform';

import Config from '../../config/Config';

const X2JS = new x2js({ attributePrefix: '$' });
X2JS.xml2string = function (xmlObj) {
  if (typeof xmlObj.xml !== 'undefined') {
    return xmlObj.xml;
  } else {
    return new window.XMLSerializer().serializeToString(xmlObj);
  }
};

function configureAjax(config) {
  const dataType = _.isArray(config.blueprintArrays) ? 'text soap' : 'text soap json';
  const envelope = {
    'SOAP:Envelope': {
      '$xmlns:SOAP': 'http://schemas.xmlsoap.org/soap/envelope/'
    }
  };

  if (config.header) {
    envelope['SOAP:Envelope']['SOAP:Header'] = config.header;
  }

  envelope['SOAP:Envelope']['SOAP:Body'] = config.body;

  // The following inputs are specific to $.soap, and meaningless to $.ajax. We don't want to mix those in...
  delete config.header;
  delete config.body;
  delete config.blueprint;
  delete config.blueprintArrays;
  delete config.preprocessor;

  // TODO: Right now we have to attach the Config.js object to the jQuery
  // namespace to be able to support this. Probably would be better if the
  // gateway was passed in during each request.
  config.url = Config.getGatewayUrl();
  config.headers = { ...config.headers, Location: window.location.href };
  config.data = X2JS.json2xml_str(envelope);
  config.method = config.method || 'POST';
  config.contentType = config.contentType || 'text/xml;charset=UTF-8';
  config.dataType = config.dataType || dataType;
  return config;
}

function resolveAjax(data, config) {
  if (config.blueprintArrays) {
    const myDoc = document.implementation.createDocument('', '', null);
    myDoc.appendChild(myDoc.adoptNode(data.firstChild.lastChild.firstChild));
    data = new x2js({
      attributePrefix: '$',
      arrayAccessFormPaths: config.blueprintArrays
    }).xml2json(myDoc);
  }

  if (_.isFunction(config.preprocessor)) {
    config.preprocessor(data);
  }

  if (!config.blueprint || !_.isPlainObject(config.blueprint)) {
    return data;
  } else {
    return transformer(data, config.blueprint);
  }
}

const jqueryExtensions = {
  async soap(config) {
    return new Promise((resolve, reject) => {
      const blueprint = config.blueprint || {};
      const preprocessor = config.preprocessor;
      const blueprintArrays = config.blueprintArrays;

      config = configureAjax(config);

      $.ajax(config)
        .done((data, textStatus, jqXHR) => {
          const resolvedData = resolveAjax(data, { blueprint, blueprintArrays, preprocessor });
          resolve(resolvedData, textStatus, jqXHR);
        })
        .fail((error, response, jqXHR) => {
          if (error.responseText.length) {
            error.responseJSON = X2JS.xml_str2json(error.responseText);

            error.message = transformer(error.responseJSON, {
              code: '$..faultcode.__text',
              string: '$..faultstring.__text',
              detail: '$..FaultDetailString.__text'
            });

            if (!error.message.detail) {
              const details = _.get(error, 'responseJSON.Envelope.Body.Fault.detail', {});
              if (details.FaultDetails) {
                delete details.FaultDetails;
              }
              if (!$.isEmptyObject(details)) {
                error.message.object = details;
                error.message.object.xml = X2JS.json2xml_str(details);
              }
            }
          }

          reject(error, response, jqXHR);
        });
    });
  }
};

export default jqueryExtensions;
